const ASKED_KEY = 'ctl-push-asked';

const storage = (): Storage | null => {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

export const hasAskedHere = (): boolean => {
  try {
    return storage()?.getItem(ASKED_KEY) != null;
  } catch {
    return false;
  }
};

export const rememberAskedHere = (at: string): void => {
  try {
    storage()?.setItem(ASKED_KEY, at);
  } catch {
    return;
  }
};
